import React from "react";
import { useSite } from "../../context/SiteContext";

const Experience = () => {
  const { experience, education } = useSite();
  return (
    <section
      id="experience"
      className="relative bg-[#0a0a0a] py-24 md:py-36 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-14">
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-300/90 mb-4">
              03 — Experience
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-stone-50 leading-tight">
              A decade in the <span className="italic">director's chair.</span>
            </h2>
          </div>
          <p className="md:col-span-7 md:col-start-6 text-stone-400 text-[16px] md:text-lg leading-[1.7]">
            From Dublin agencies to Amsterdam fintechs to Web3 studios —
            each role has been about scaling creative output without
            losing the thing that makes it feel human.
          </p>
        </div>

        <ol className="relative border-l border-zinc-800 ml-2 md:ml-6">
          {experience.map((job) => (
            <li key={job.company + job.period} className="pl-6 md:pl-10 pb-14 relative">
              <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-amber-300 ring-4 ring-[#0a0a0a]" />
              <div className="grid md:grid-cols-12 gap-4 md:gap-10">
                <div className="md:col-span-3">
                  <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-stone-500">
                    {job.period}
                  </p>
                  <p className="mt-1 text-xs text-stone-600">{job.location}</p>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-display text-2xl md:text-3xl text-stone-50">
                    {job.role}
                    <span className="text-stone-500"> — </span>
                    <span className="italic text-amber-200/90">{job.company}</span>
                  </h3>
                  {job.teamSize && (
                    <span className="inline-block mt-3 text-[10px] uppercase tracking-[0.22em] text-amber-300/80 border border-amber-400/30 bg-amber-400/5 px-2.5 py-1">
                      {job.teamSize}
                    </span>
                  )}
                  <ul className="mt-4 space-y-2 text-stone-300 text-[15px] leading-[1.7] max-w-2xl">
                    {job.bullets.map((b, i) => (
                      <li key={i} className="flex gap-3">
                        <span className="text-amber-300/80 mt-0.5">—</span>
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 pt-10 border-t border-zinc-900 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-stone-500">
              Education
            </p>
          </div>
          <div className="md:col-span-8">
            {education.map((e) => (
              <div key={e.school}>
                <h4 className="font-display text-2xl text-stone-50">
                  {e.degree} — <span className="italic">{e.school}</span>
                </h4>
                <p className="mt-1 text-stone-500 text-sm">{e.period}</p>
                {e.note && (
                  <p className="mt-3 text-stone-400 text-sm max-w-2xl leading-relaxed">
                    {e.note}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
